/**
 * "Chat on WhatsApp": a floating button on the public site that opens a chat with
 * our WhatsApp number (the sales chatbot answers at once). The number is
 * brand.json's `whatsapp`; without it, nothing shows.
 */
import { useRouterState } from "@tanstack/react-router";
import { MessageCircle } from "lucide-react";

import { brand } from "@/brand";

function whatsappLink(text = `Hi ${brand.name}`): string | null {
  const digits = (brand.whatsapp ?? "").replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : null;
}

// forms where a floating button would sit over the fields on a phone
const HIDDEN_ON = ["/signup", "/login", "/forgot-password", "/set-password", "/payment-result", "/pro-offer"];

export function WhatsAppChat() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const href = whatsappLink();
  if (!href || HIDDEN_ON.some((p) => path.startsWith(p))) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-chat"
      className="fixed right-4 bottom-4 z-30 inline-flex items-center gap-2 rounded-full bg-[#25d366] px-4 py-3 text-sm font-semibold text-white shadow-lg transition hover:brightness-95 sm:right-6 sm:bottom-6"
    >
      <MessageCircle className="size-5" aria-hidden />
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
